import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Button } from "@mui/material";
import { Link, useRouteError } from "react-router-dom";
import styled from "styled-components";

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background-color: ${(props) => props.theme.bodyBackground};
`;

const Content = styled.div`
  width: 420px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`;

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 8px;
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.redSoft};
  color: ${(props) => props.theme.colors.red};

  svg {
    width: 22px;
    height: 22px;
  }
`;

const Heading = styled.h1`
  margin: 0;
  font-size: 18px;
  font-weight: 650;
  letter-spacing: -0.01em;
  color: ${(props) => props.theme.textColor};
`;

const Message = styled.p`
  margin: 0;
  font-size: 13.5px;
  line-height: 1.5;
  color: ${(props) => props.theme.secondaryTextColor};
  overflow-wrap: anywhere;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
`;

export default function ErrorPage() {
  const error: any = useRouteError();

  console.error(error);

  const clearCaches = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  };

  return (
    <PageContainer>
      <Content>
        <IconWrap>
          <ExclamationTriangleIcon />
        </IconWrap>
        <Heading>Sorry, an unexpected error has occurred.</Heading>
        <Message>{error.statusText || error.message}</Message>

        <Actions>
          <Button component={Link} to="/" variant="contained">
            Back to start
          </Button>
          <Button
            component={Link}
            to=""
            variant="outlined"
            color="inherit"
            onClick={() => clearCaches()}
          >
            Clear caches
          </Button>
        </Actions>
      </Content>
    </PageContainer>
  );
}
